module.exports = __webpack_public_path__ + "img/logo_bot.615d6d5f.png";